exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".part-footer-email[data-v-74b870f9]{color:#6e6bce;font-weight:400;font-family:Open Sans,sans-serif;display:block}.part-footer-email[data-v-74b870f9]:hover{color:#51acff;text-decoration:none}.inline[data-v-74b870f9]{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74b870f9","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/footer/Email.vue
// module id = 5f468cbf9ec5c41d1fec
// module chunks = 0